import React from 'react';
import { Vara } from '../../components/vara';
import smurtlist from '../../resources/smurt.json';
import './styles.css';

const Smurt= () => {

  const getImagePath = (imageName) => {
    return require(`../../resources/smurt/${imageName}`);
  };

  const bannerUrl = require('../../resources/cover_samlokur.jpeg');

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="relative h-52 w-full overflow-hidden">
        <img src={bannerUrl} alt="Smurða" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/40 flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-4xl font-serif text-white mb-2">Smurt</h1>
          <div className="w-12 h-0.5 bg-[#C29979] mb-3"></div>
          <p className="text-white/80 font-serif text-sm">Bakað og smurt alla morgna</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-10">
        <ul className="flex flex-wrap justify-center">
          {smurtlist.items.map((item) => (
            <Vara
              key={item.id}
              name={item.name}
              image={getImagePath(item.images)}
              description={item.description}
            />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Smurt;
